export default __webpack_public_path__ + "static/media/contact.c813cab4.png";